export default __webpack_public_path__ + "static/media/_chainlink.39165f8a.svg";